import checkinApiReducer from "./checkinApiSlice";

export default checkinApiReducer;
export {
  checkinDocumentThunk,
  checkinDocumentsBulkThunk,
  checkinExistingDocumentsBulkThunk,
  clearCheckinError,
  BROWSE_FILE_FIELD,
} from "./checkinApiSlice";
